import { ReusablePaymentMethodBase } from './reusable-payment-method-base';

export interface TeamBudget extends ReusablePaymentMethodBase {
  type: 'TEAM_BUDGET';
  budget: number;
  groupName: string;
  issuedBy: string;
}
